export default "__VITE_ASSET__BuLyiPKQ__"